import React from 'react'
import { Box, Image, SxProps, SxStyleProp } from 'rebass'
import { TextV2 as Text, ICMSTextV2Props, TEXT_FONT_COLOR } from '../Text/TextV2'
import { containerStyles, outerContainerStyles, textContainerStyles } from './TextBlockList.styles'

export interface ITextBlockListItemProps {
  iconSrc: string
  iconColor: TEXT_FONT_COLOR
  iconAlt: string
  title?: ICMSTextV2Props
  body?: ICMSTextV2Props
  sx?: SxProps | SxStyleProp
}

export interface ITextBlockListProps {
  list: ITextBlockListItemProps[]
  sx?: SxProps | SxStyleProp
  itemSx?: SxStyleProp
}

export const TextBlockList = ({ list, sx, itemSx }: ITextBlockListProps) => {
  return (
    <Box sx={{ width: '100%', ...sx }}>
      {list.map((item: ITextBlockListItemProps, index: number) => (
        <TextBlockListItem
          key={`text-block-list-item-${index}`}
          iconSrc={item.iconSrc}
          iconAlt={item.iconAlt}
          iconColor={item.iconColor}
          title={item.title}
          body={item.body}
          sx={itemSx}
        />
      ))}
    </Box>
  )
}

export const TextBlockListItem = ({ iconSrc, iconAlt, iconColor, title, body, sx }: ITextBlockListItemProps) => {
  return (
    <Box sx={outerContainerStyles}>
      <Box sx={{ ...containerStyles, ...sx }}>
        {iconSrc && (
          <Image
            sx={{
              color: iconColor,
              margin: ['0 auto'],
            }}
            src={iconSrc}
            alt={iconAlt}
          />
        )}
        <Box sx={textContainerStyles}>
          {title ? (
            <Text
              tag={title.tag}
              textFontColor={title.textFontColor}
              textFontStyle={title.textFontStyle}
              sx={{
                paddingBottom: '5px',
                ...(title.sx || {}),
              }}
            >
              {title.text}
            </Text>
          ) : null}
          {body ? (
            <Text
              tag={body.tag}
              textFontColor={body.textFontColor}
              textFontStyle={body.textFontStyle}
              sx={{ paddingBottom: '0px', ...(body.sx || {}) }}
            >
              {body.text}
            </Text>
          ) : null}
        </Box>
      </Box>
    </Box>
  )
}
